import React, { useState } from 'react';
import DatabaseAdmin from '../DatabaseAdmin/DatabaseAdmin';
import Stat from '../Main/Home';
import PageTabs from '../components/PageTabs';
import './Pages.scss';

function Admin() {
  const [activeTab, setActiveTab] = useState('settings');

  const tabs = [
    { id: 'settings', label: 'Настройки' },
    { id: 'stat', label: 'Статистика' },
  ];

  return (
    <div className="top-level-page-container">
      <PageTabs activeTab={activeTab} setActiveTab={setActiveTab} tabs={tabs} />
      <div className="page-content">
        {activeTab === 'settings' && <DatabaseAdmin />}
        {activeTab === 'stat' && <Stat />}
      </div>
    </div>
  );
}

export default Admin;
